import { render, staticRenderFns } from "./ModifySetting.vue?vue&type=template&id=216fdefb&scoped=true&"
import script from "./ModifySetting.vue?vue&type=script&lang=js&"
export * from "./ModifySetting.vue?vue&type=script&lang=js&"
import style0 from "./ModifySetting.vue?vue&type=style&index=0&id=216fdefb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216fdefb",
  null
  
)

export default component.exports